import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetchUserPermissions = createAsyncThunk(
    "userPermissions/fetch",
    async ({ userId, organizationId }, { rejectWithValue }) => {
        const jwtToken = localStorage.getItem("jwt_token");
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/reward_permission?user_id=${userId}&organisation_id=${organizationId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            return res.data.data
        } catch (err) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

const userPermissionsSlice = createSlice({
    name: "userPermissions",
    initialState: {
        rewardPermissions: {},
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserPermissions.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUserPermissions.fulfilled, (state, action) => {
                state.rewardPermissions = action.payload;
                state.loading = false;
            })
            .addCase(fetchUserPermissions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default userPermissionsSlice.reducer;
